import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download\"><path d=\"M923.3 807.1c-32.1 55.5-91.8 90-155.8 90h-488c-64.1 0-123.8-34.5-155.8-90-8-13.9-3.3-31.6 10.6-39.6 13.9-8.1 31.6-3.3 39.6 10.6 21.7 37.6 62.2 61 105.6 61h488.1c43.4 0 83.9-23.4 105.6-61 8-13.8 25.9-18.6 39.6-10.6 13.8 8 18.6 25.7 10.5 39.6zM503 714.6c2.7 2.7 5.9 4.8 9.5 6.3 3.5 1.5 7.3 2.2 11.1 2.2s7.5-0.8 11.1-2.2c3.6-1.5 6.8-3.6 9.5-6.3l213.7-213.7c11.3-11.3 11.3-29.6 0-41s-29.6-11.3-41 0L552.5 624.2V92.8c0-16-13-29-29-29s-29 13-29 29v531.4L330.3 459.9c-11.3-11.3-29.6-11.3-41 0s-11.3 29.6 0 41L503 714.6z\" p-id=\"19958\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/download.svg
// module id = +H2/
// module chunks = 534